document.addEventListener("DOMContentLoaded", function () {
  // Cache DOM elements
  const tbybBtn = document.getElementById("tbyb_button");
  const tbybBtnLoader = document.getElementById("tbyb_btn_loader");
  const tbybErrorSpan = document.getElementById("tbyb_error");
  const loginBtn = document.getElementById("login_button");
  const tbybMainVariantNode = document.getElementById("tbyb_main_variant");

  // Initialize data from DOM
  const tbyb_uids = JSON.parse(document.getElementById("tbyb_uids").textContent);
  const tbyb_main_product = JSON.parse(document.getElementById("data_product_json").textContent);
  const tbyb_main_variant = JSON.parse(document.getElementById("tbyb_main_variant").textContent);

console.log('tbyb_main_product' , tbyb_main_product);

  let sample_variant = null;
  const tbyb_variant_el = document.getElementById("tbyb_variant");
  if (tbyb_variant_el) {
    sample_variant = JSON.parse(tbyb_variant_el.textContent);
  }

  // Setup login button handler
    if (loginBtn) {
    loginBtn.addEventListener("click", function () {
      // Add #rivo to the current URL
      const currentUrl = window.location.href;
      const separator = currentUrl.includes('#') ? '' : '#';
      window.location.href = currentUrl + separator + 'rivo';
    });
  }


  let main_product_variant = tbyb_main_product.variants.find(i => i.id == tbyb_main_variant);

  // --- Market-aware price helpers (Shopify Markets) ---
  // Goal: avoid hardcoded "$" so the currency formatting updates when market changes (USD → CAD, etc.)
  function getActiveCurrencyCode() {
    try {
      const code =
        window?.Shopify?.currency?.active ||
        window?.Shopify?.currency?.iso_code ||
        window?.Shopify?.currency?.currency ||
        document?.documentElement?.getAttribute('data-shopify-currency') ||
        null;
      return code ? String(code).toUpperCase() : null;
    } catch (e) {
      return null;
    }
  }

  function formatCurrencyAmount(amountNumber, currencyCode) {
    try {
      if (typeof amountNumber !== 'number' || Number.isNaN(amountNumber)) return null;
      if (currencyCode) {
        // Shopify commonly displays CAD as "$" (not "CA$") when the locale is en-CA.
        // Also prefer narrow symbols to avoid "CA$" / "US$" prefixes.
        const normalized = String(currencyCode).toUpperCase();
        const locale =
          normalized === 'CAD' ? 'en-CA' :
          normalized === 'USD' ? 'en-US' :
          undefined;
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: normalized,
          currencyDisplay: 'narrowSymbol',
        }).format(amountNumber);
      }
    } catch (e) {
      // fall through to USD-style fallback below
    }
    return `$${amountNumber.toFixed(2)}`;
  }

  function getMainVariantMarketPrice(variant) {
    const cents = variant && typeof variant.price === 'number' ? variant.price : null;
    const amountNumber = cents != null ? cents / 100 : null;
    const currencyCode = getActiveCurrencyCode();
    const formatted = amountNumber != null ? formatCurrencyAmount(amountNumber, currencyCode) : null;
    return {
      amountNumber,
      amountFixed: amountNumber != null ? amountNumber.toFixed(2) : null,
      currencyCode,
      formatted,
    };
  }

  // Persist main product price (in dollars) for downstream pages (e.g., Rivo order page)
  function persistTbybMainPriceFromVariant(variant) {
    try {
      if (!variant || typeof variant.price !== 'number') return;
      const priceDollars = (variant.price / 100).toFixed(2);
      if (document && document.body) {
        // Prefer the locked price stored when the sample was added; fallback to current variant price
        let stored = null;
        try { stored = localStorage.getItem('tbyb_main_price'); } catch (e) {}
        const validStored = stored && !Number.isNaN(parseFloat(stored));
        const bodyPrice = validStored ? String(stored) : priceDollars;
        document.body.setAttribute('tbyb-main-price', bodyPrice);
      }
    } catch (e) {}
  }
  // Write persistent price ONLY when a sample is added (do not call during PDP navigation)
  // This ensures only ONE product price is stored at a time (one sample at a time logic).
  // When a new sample is added, it overwrites the previous price.
  function setTbybPriceInLocalStorage(priceDollars) {
    try {
      if (!priceDollars) return;
      localStorage.setItem('tbyb_main_price', String(priceDollars));
    } catch (e) {
      console.error('[TBYB] Failed to set localStorage tbyb_main_price:', e);
    }
  }
  // Initialize on load
  persistTbybMainPriceFromVariant(main_product_variant);

  // Helper function to get sample variant by ID
  function getSampleVariant(variant_id) {
    const tbyb_variant_el = document.getElementById("tbyb_variant_" + variant_id);
    if (tbyb_variant_el) {
      return JSON.parse(tbyb_variant_el.textContent);
    }
    return null;
  }

  /**
   * Build set of all sample SKUs already ordered by customer (lifetime).
   * tbyb_uids format: { "mainProductId": ["sampleSKU1", "sampleSKU2"], ... }
   * Customer can try each sample SKU only once in lifetime.
   */
  function getOrderedSampleSkusSet() {
    if (!tbyb_uids || typeof tbyb_uids !== "object") return [];
    const skus = [];
    Object.keys(tbyb_uids).forEach(function (productId) {
      const list = tbyb_uids[productId];
      if (Array.isArray(list)) {
        list.forEach(function (sku) {
          const normalized = String(sku || "").trim().toUpperCase();
          if (normalized && skus.indexOf(normalized) === -1) skus.push(normalized);
        });
      }
    });
    return skus;
  }

  /** Return true if this sample SKU was already ordered by customer (lifetime). */
  function isSampleSkuAlreadyOrdered(sampleSku) {
    const ordered = getOrderedSampleSkusSet();
    if (ordered.length === 0) return false;
    const normalized = String(sampleSku || "").trim().toUpperCase();
    return normalized ? ordered.indexOf(normalized) !== -1 : false;
  }

  // Helper function to update button state based on conditions
  function updateButtonState() {
    console.log("Updating button")
    // Get the current sample variant for the selected main variant
    const currentSampleVariant = getSampleVariant(main_product_variant.id);

    // Hide the entire button wrapper if no sample variant exists for current selection
    const tbybButtonWrap = document.querySelector('.tbyb_add_button_wrap');
    if (!currentSampleVariant) {
      if (tbybButtonWrap) {
        tbybButtonWrap.style.display = 'none';
      }
      return;
    } else {
      // Show button wrapper if sample variant exists
      if (tbybButtonWrap) {
        tbybButtonWrap.style.display = 'block';
      }
    }

    // Update the sample_variant variable
    sample_variant = currentSampleVariant;
    console.log("sample_variant", sample_variant)

    // Lifetime rule: same sample SKU can only be tried once per customer
    const sampleSku = (sample_variant && (sample_variant.sku || sample_variant.sku === 0)) ? String(sample_variant.sku) : "";
    console.log("sampleSku", sampleSku)
    if (sampleSku && isSampleSkuAlreadyOrdered(sampleSku)) {
      tbybBtn.setAttribute("disabled", "disabled");
      tbybBtn.style.opacity = "0.6";
      tbybBtn.style.cursor = "not-allowed";
      if (tbybErrorSpan) {
        tbybErrorSpan.textContent = "You have already tried this sample. One trial per sample per customer.";
        tbybErrorSpan.style.display = "block";
      }
      return;
    }
    console.log("Not ordered already")

    // Check if cart already has a sample first (only one trial sample per order)
    checkCartForSample()
      .then(() => {
        console.log("no sample on cart")
        // No sample in cart; no limit on how many different samples customer can try (only same SKU cannot repeat)
        tbybBtn.removeAttribute("disabled");
        tbybErrorSpan.textContent = "";
        tbybBtn.style.opacity = "1";
        tbybBtn.style.cursor = "pointer";
      })
      .catch(() => {
        console.log("sample on cart")
        // Sample already in cart, grey out button
        tbybBtn.setAttribute("disabled", "disabled");
        tbybBtn.style.opacity = "0.6";
        tbybBtn.style.cursor = "not-allowed";
        tbybErrorSpan.textContent = 'Only one trial sample per order allowed. Remove the current sample from your cart if you want to try this one instead.';
      });
  }

  console.log("tbybBtn", tbybBtn)

  // Initialize TBYB functionality
  if (tbybBtn) {
    console.log("tbybBtn", tbybBtn)
        if (!tbybBtn.getAttribute("data-original-text")) {
      tbybBtn.setAttribute("data-original-text", tbybBtn.textContent);
    }

    // Set initial sample variant if not already set
    if (!sample_variant) {
      sample_variant = getSampleVariant(main_product_variant.id);
    }

    // Set initial button state
    updateButtonState();

    // Setup variant change listener
    const product_form = document.getElementById('main_section_p_' + tbybBtn.getAttribute("data-product-id"));
    if (product_form) {
      product_form.addEventListener("variant:changed", function (event) {
        main_product_variant = event.detail.variant;

        // Update main variant node
        if (tbybMainVariantNode) {
          tbybMainVariantNode.textContent = JSON.stringify(main_product_variant.id);
        }
        // Persist price for downstream use
        persistTbybMainPriceFromVariant(main_product_variant);

        // Update button state (this will also update sample_variant)
        updateButtonState();
      });
    }
  }


  // Helper function to check if cart already has a sample
  function checkCartForSample() {
    return fetch(`${window.location.origin}/cart.js`)
      .then(res => res.json())
      .then(data => {
        const hasSampleInCart = Array.isArray(data.items) && data.items.some(cartItem => {
          return cartItem?.properties?._app === 'tbyb';
        });

        if (hasSampleInCart) {
          return Promise.reject("Sample already in cart");
        }
        return data;
      });
  }

  // Helper function to add sample to cart
  function addToCartSample(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === 'too_many_requests' || data.status > 400) {
          let errorMessage = data.description || data.message || "Something went wrong. Please try again.";

          // Replace "already sold out" with "out of stock" for better user experience
          errorMessage = errorMessage.replace(/already sold out/gi, 'out of stock');
          errorMessage = errorMessage.replace(/sold out/gi, 'out of stock');

          if (tbybErrorSpan) tbybErrorSpan.textContent = errorMessage;
          throw new Error(errorMessage);
        }
        return data;
      });
  }


  // Sync with global onVariantChange from assets/global.js
  document.addEventListener("onVariantChange", function (event) {
    try {
      if (!event?.detail) return;
      const variant = event.detail;
      main_product_variant = variant;
      if (tbybMainVariantNode) {
        tbybMainVariantNode.textContent = JSON.stringify(variant.id);
      }
      // Persist price for downstream use
      persistTbybMainPriceFromVariant(main_product_variant);
      // Update button state when variant changes
      if (tbybBtn) {
        updateButtonState();
      }
    } catch (e) {
      // Silent fail
    }
  });

  // Listen for cart updates (from Shopify theme events)
  document.addEventListener('cart:updated', function() {
    if (tbybBtn) {
      updateButtonState();
    }
  });

  // Listen for custom cart change events
  document.addEventListener('cartUpdated', function() {
    if (tbybBtn) {
      updateButtonState();
    }
  });

  // Periodically check cart state as fallback (every 3 seconds)
  if (tbybBtn) {
    setInterval(() => {
      updateButtonState();
    }, 3000);
  }

});

// Modal functionality
(function() {
  // Handle clicking outside modal to close it
  function handleOutsideClick(event) {
    const modal = document.getElementById('ybybModal');
    const inner = document.getElementById('tbyb_modal_inner');

    if (modal?.style.display === 'block' && inner && !inner.contains(event.target)) {
      modalClose();
    }
  }

  // Close modal function
  function modalClose() {
    const modal = document.getElementById('ybybModal');
    if (!modal) return;

    modal.style.display = 'none';

    // Clear any existing TBYB error message when modal closes
    const tbybErrorSpan = document.getElementById('tbyb_error');
    if (tbybErrorSpan) tbybErrorSpan.style.display = 'none';

    // Remove the event listener when modal is closed
    document.removeEventListener('mousedown', handleOutsideClick);
  }

  // Open modal function
  function openYbybModal() {
    const modal = document.getElementById('ybybModal');
    if (!modal) return;

    modal.style.display = 'block';
     const tbybErrorSpan = document.getElementById('tbyb_error');
    if (tbybErrorSpan) tbybErrorSpan.style.display = 'block';
    $('#ybybModal').modal({ backdrop: false });

    // Add event listener for outside click after a brief delay
    setTimeout(() => {
      document.addEventListener('mousedown', handleOutsideClick);
    }, 0);
  }

  // Expose functions globally
  window.openYbybModal = openYbybModal;
  window.modalClose = modalClose;
})();


